import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { gradient, greys, colors } from "@clockwise/web-commons/src/styles/color.styles";

const hero: CSSProperties = {
  padding: spacing.std,
  background: gradient,
};

const body: CSSProperties = {
  overflowY: "scroll",
};

export const close = {
  style: {
    position: "absolute",
    top: 0,
    right: 0,
  } as CSSProperties,
  icon: {
    htmlColor: greys.white,
  },
};

export const name: CSSProperties = {
  color: greys.white,
  marginTop: 15,
  marginBottom: 5,
  overflow: "hidden",
  whiteSpace: "nowrap",
};

const email: CSSProperties = {
  fontSize: size.md,
  color: greys.white,
  lineHeight: 1.25,
  overflow: "hidden",
  whiteSpace: "nowrap",
};

const divider: CSSProperties = {
  // marginBottom: spacing.std,
  // marginTop: spacing.std,
};

const menuItem: CSSProperties = {
  minHeight: 48,
};

export const menuItemIcon = {
  htmlColor: greys.slate,
};

export const fiberNewIcon = {
  htmlColor: colors.green.darker,
};

const listItemText__new: CSSProperties = {
  display: "flex",
  alignItems: "center",
  margin: "4px 0px",
  "& > p:last-child": {
    marginLeft: 5,
  },
};

const listItemText: CSSProperties = {
  // fontSize: 16,
};

export const styles = {
  hero,
  body,
  email,
  divider,
  menuItem,
  listItemText,
  listItemText__new,
};
